import { Skeleton } from "@mui/material";
import Plot from "components/plotly/LocalisedPlot";
import { useTenant } from "hooks/settings";
import { useGetInventoryEstimateAtTimestampQuery } from "src/store/api/generatedApi";
import { useMaterialColor, useMaterialIdToData } from "hooks/useMaterials";

export const CurrentInventoryPieChart = ({
  timestamp,
}: {
  timestamp: string;
}) => {
  const tenant = useTenant();
  const materialIdToData = useMaterialIdToData();
  const materialColor = useMaterialColor();
  const { data, isFetching } = useGetInventoryEstimateAtTimestampQuery({
    tenantName: tenant,
    timestamp: timestamp,
    materialMetadataSetId: "default",
    materialPhysicsSetId: "default",
  });

  if (isFetching) return <Skeleton variant="rectangular" height={160} />;

  if (!data) return null;

  const filteredData = data.items.filter(
    (item) => item.quantity && item.quantity > 0
  );

  const values = filteredData.map((item) => Math.round(item.quantity ?? 0));
  const labels = filteredData.map(
    (item) =>
      materialIdToData?.[item.material_id]?.name ??
      `Material ${item.material_id}`
  );
  const colors = filteredData.map((item) =>
    materialColor.getColor(
      materialIdToData?.[item.material_id]?.name ??
        `Material ${item.material_id}`
    )
  );

  return (
    <Plot
      data={[
        {
          type: "pie",
          values: values,
          labels: labels,
          hole: 0.4,
          marker: {
            colors: colors,
          },
          textinfo: "value",
          textposition: "inside",
        },
      ]}
      layout={{
        margin: { t: 20, b: 20, l: 20, r: 20 },
        showlegend: true,
        height: 200,
      }}
      config={{
        responsive: true,
      }}
    />
  );
};
